export enum UserGroups {
  SKF,
  WIND,
  RAIL,
  PORTAL,
  COMORAIL,
  INDUSTRY,
  WIND_BT_ACCESS,
  INDUSTRY_BT_ACCESS,
  CUSTOMER_ACCESS,
  CV4REMAN_ACCESS,
  REMANXP_ACCESS

}

export interface IUserAuth {
  getUserName(): string;
  getUserEmail(): string;
  getUserGroups(): string[];
  getIdToken(): string;
  hasTokenExpired(): boolean;
  isUserInGroup(userGroup: string): boolean;
}

export enum GroupNameEnum {
  WIND = 'windGroupName',
  RAIL = 'railGroupName',
  PORTAL = 'portalGroupName',
  INDUSTRY = 'industryGroupName',
  WIND_BT_PORTAL = 'windBTAccessGroupName',
  INDUSTRY_BT_PORTAL = 'industryBTAccessGroupName',
  CUSTOMER_PORTAL = 'customerPortalAccessGroupName',
  CV4REMAN_PORTAL = 'cv4RemanPortalAccessGroupName',
  REMANXP_PORTAL = 'remanXPPortalAccessGroupName'
}

export enum WebURLEnum {
  WIND = 'windWebUrl',
  RAIL = 'railWebUrl',
  PORTAL = 'portalWebUrl',
  INDUSTRY = 'industryWebUrl',
  WIND_BT_PORTAL = 'railWebUrl',
  INDUSTRY_BT_PORTAL = 'railWebUrl',
  CUSTOMER_PORTAL = 'customerWebUrl',
  CV4REMAN_PORTAL = 'cv4RemanWebUrl',
  REMANXP_PORTAL = 'remanXPWebUrl'
}

type GroupWebURLMapType = {
  [id in GroupNameEnum]: WebURLEnum;
};

export type GenericGroupWebURLMapType = {
  [id in string]: string;
};

export const GroupWebURLMap: GroupWebURLMapType = {
  [GroupNameEnum.WIND]: WebURLEnum.WIND,
  [GroupNameEnum.RAIL]: WebURLEnum.RAIL,
  [GroupNameEnum.PORTAL]: WebURLEnum.PORTAL,
  [GroupNameEnum.INDUSTRY]: WebURLEnum.INDUSTRY,
  [GroupNameEnum.WIND_BT_PORTAL]: WebURLEnum.RAIL,
  [GroupNameEnum.INDUSTRY_BT_PORTAL]: WebURLEnum.RAIL,
  [GroupNameEnum.CUSTOMER_PORTAL]: WebURLEnum.CUSTOMER_PORTAL,
  [GroupNameEnum.CV4REMAN_PORTAL]: WebURLEnum.CV4REMAN_PORTAL,
  [GroupNameEnum.REMANXP_PORTAL]: WebURLEnum.REMANXP_PORTAL
};
